<script setup>
import { ref, onMounted, onUnmounted, reactive, nextTick } from 'vue'
import { useRouter } from 'vue-router'
import { scrollTo } from 'vue-scrollto';
import productsli1 from "@/assets/images/icon/productsli1.png"
import productsli2 from "@/assets/images/icon/productsli2.png"
import productsli3 from "@/assets/images/icon/productsli3.png"
import productsli4 from "@/assets/images/icon/productsli4.png"
import productsli5 from "@/assets/images/icon/productsli5.png"
import productsli6 from "@/assets/images/icon/productsli6.png"
import productsli7 from "@/assets/images/icon/productsli7.png"
import productsli8 from "@/assets/images/icon/productsli8.png"
import pricingli1 from "@/assets/images/icon/pricingli1.png"
import pricingli2 from "@/assets/images/icon/pricingli2.png"
import solutionsli1 from "@/assets/images/icon/solutionsli1.png"
import solutionsli2 from "@/assets/images/icon/solutionsli2.png"
import solutionsli3 from "@/assets/images/icon/solutionsli3.png"
import solutionsli4 from "@/assets/images/icon/solutionsli4.png"
import solutionsli5 from "@/assets/images/icon/solutionsli5.png"
import aboutli1 from "@/assets/images/icon/aboutli1.png"
import aboutli2 from "@/assets/images/icon/aboutli2.png"
import aboutli3 from "@/assets/images/icon/aboutli3.png"
import aboutli4 from "@/assets/images/icon/aboutli4.png"
import aboutli5 from "@/assets/images/icon/aboutli5.png"
const router = useRouter()

const isTop = ref(true)
const showStatus = ref(false)
const scrollTop = ref(0)
const headerHeight = ref(0)
const isScrolling = ref(false)

const isMobileMenuOpen = ref(false) // 新增：移动端菜单状态
const windowWidth = ref(window.innerWidth) // 新增：窗口宽度

const menuRef = ref([])

const navItems = reactive([
  {
    path: '/',
    text: '首页',
    isMenus: false,
    ariaExpanded: false,
    menuItems: [],
    menuItems1: [],
    extensionsItems: []
  },
  {
    path: '/products',
    text: '功能',
    isMenus: true,
    ariaExpanded: false,
    title: 'Amazon VC ERP',
    extensions: 'DOULLY SaaS平台',
    /* 设计稿「官网-顶部下拉」主区是 3×2 六格（顺序：获取订单 / 自动履约 / 智能账务处理 /
       数据统计分析 / 数据统计分析 / 数据统计分析）。稿子里后三格的标题与副标题是重复的占位文案，
       这里按稿照搬把网格凑满；如果要换成真实功能模块，改 text/remake 即可，
       id 必须仍是功能页（productsFeatures.vue）里存在的锚点，否则下拉点了没反应。 */
    menuItems: [
      {
        id: 'getOrder',
        img: productsli1,
        text: '获取订单',
        remake: '无缝集成亚马逊，自动获取PO、DF订单',
      },
      {
        id: 'intelligentAccountingPprocessing',
        img: productsli3,
        text: '智能账务处理',
        remake: 'RPA智能化财务，省时省力',
      },
      {
        id: 'dataStatisticalAnalysis',
        img: productsli4,
        text: '数据统计分析',
        remake: '全年数据统计分析，业务账务及时掌握',
      },
    ],
    menuItems1: [
      {
        id: 'automaticFulfillment',
        img: productsli2,
        text: '自动履约',
        remake: '订单履约全链路自动化处理，无需人工处理',
      },
      {
        id: 'dataStatisticalAnalysis',
        img: productsli4,
        text: '数据统计分析',
        remake: '全面数据统计分析，业务财务及时掌握',
      },
      {
        id: 'dataStatisticalAnalysis',
        img: productsli4,
        text: '数据统计分析',
        remake: '全年数据统计分析，业务账务及时掌握',
      },
    ],
    extensionsItems: [
      {
        id: 'productsFooter',
        text: '多租户，支持独立部署',
        img: productsli5,
      },
      {
        id: 'productsFooter',
        text: '完美集成电商仓储物流',
        img: productsli6,
      },
      {
        id: 'productsFooter',
        text: '技术优势，性能优越',
        img: productsli7,
      },
      {
        id: 'productsFooter',
        text: '风格简约布局清晰',
        img: productsli8,
      },
    ]
  },
  {
    path: '/pricing',
    text: '价格',
    isMenus: true,
    ariaExpanded: false,
    title: '价格',
    extensions: '购买中常见问题',
    menuItems: [
      {
        id: 'pricing',
        img: pricingli1,
        text: 'Amazon VC ERP',
        remake: 'Amazon VC ERP的价格'
      },
    ],
    extensionsItems: [
      {
        id: 'frequentlyAskedQuestions',
        text: '如何从 Particle Lib获取更新？',
        img: pricingli2,
      },
      {
        id: 'frequentlyAskedQuestions',
        text: '购买后我可以随时更新版本',
        img: pricingli2,
      },
      {
        id: 'frequentlyAskedQuestions',
        text: '购买后我可以随时更新版本',
        img: pricingli2,
      },
      {
        /* 设计稿最后一档：红字 + 右向箭头 */
        id: 'frequentlyAskedQuestions',
        text: '更多内容',
        img: pricingli2,
        arrow: true,
      },
    ]
  },
  {
    path: '/solutions',
    text: '服务',
    isMenus: true,
    ariaExpanded: false,
    title: 'DOULLY SaaS平台',
    extensions: 'SaaS+定制',
    menuItems: [
      {
        id: 'requestTrial',
        img: solutionsli1,
        text: '申请试用',
        remake: '试用到期后，如需继续体验可以联系专属客户经理'
      },
      {
        id: 'accountManagement',
        img: solutionsli3,
        text: '账户管理',
        remake: '试用账户注册及密码管理'
      },
    ],
    menuItems1: [
      {
        id: 'onlineConsultation',
        img: solutionsli2,
        text: '在线咨询',
        remake: '任何问题随时随地联系我们'
      },
      {
        id: 'contactInformation',
        img: solutionsli4,
        text: '联系方式',
        remake: '获取更多资料，请联系我们'
      },
    ],
    extensionsItems: [
      {
        id: 'on-demandCustomization',
        text: '支持按需定制，联合共建',
        img: solutionsli5,
      },
    ]
  },
  {
    path: '/about',
    text: '知道',
    isMenus: true,
    ariaExpanded: false,
    title: '知识与技巧',
    extensions: '行业资讯',
    menuItems: [
      {
        id: 'expertKnowledge',
        img: aboutli1,
        text: '专业知识',
        remake: '有关重要业务主题的文章'
      },
      // {
      //   id: 'customerStories',
      //   img: aboutli3,
      //   text: '客户故事',
      //   remake: '成功客户案例及客户评价'
      // },
    ],
    menuItems1: [],
    extensionsItems: [
      {
        id: 'hotTopics',
        text: '2025年亚马逊销量暴增',
        img: aboutli5,
      },
    ]
  }
])

// 顶部下拉「主入口」：把 menuItems / menuItems1 交错摊平成一张 3 列卡片网格。
// 设计稿网格里的顺序是「获取订单 / 自动履约 / 智能账务处理 / 数据统计分析」，
// 正好是两个数组依次相间 —— 只改排布，不动数据本身。
const mainEntries = (item) => {
  const a = item.menuItems || []
  const b = item.menuItems1 || []
  const out = []
  for (let i = 0; i < Math.max(a.length, b.length); i++) {
    if (a[i]) out.push(a[i])
    if (b[i]) out.push(b[i])
  }
  return out
}

const activeIndex = ref(-1)

const handleScroll = () => {

  isScrolling.value = true
  // 获取滚动位置
  const scrollPosition = window.scrollY || document.documentElement.scrollTop
  scrollTop.value = scrollTop.value || scrollPosition

  let abs = scrollPosition - scrollTop.value
  if (Math.abs(abs) > headerHeight.value) {
    if ((!isTop.value && abs < 0) || (isTop.value && abs > 0)) {
      isTop.value = !isTop.value
    }
    scrollTop.value = scrollPosition
  }
  // isTop.value = scrollPosition === 0

  // 滚动超过100px才显示状态提示
  showStatus.value = scrollPosition > 100

  // 滚动时收起展开的菜单
  if (activeIndex.value !== -1) {
    closeAllMenus()
  }

  // 滚动时关闭移动端菜单
  if (isMobileMenuOpen.value) {
    closeMobileMenu()
  }

  // 重置滚动标记
  setTimeout(() => {
    isScrolling.value = false
  }, 150)
}

// 监听窗口大小变化
const handleResize = () => {
  windowWidth.value = window.innerWidth
  // 如果窗口宽度大于1280px，确保移动端菜单关闭
  if (windowWidth.value > 1280 && isMobileMenuOpen.value) {
    closeMobileMenu()
  }
}

// 关闭所有菜单
const closeAllMenus = () => {
  if (activeIndex.value !== -1) {
    navItems[activeIndex.value].ariaExpanded = false
    activeIndex.value = -1
  }
}

// 切换移动端菜单
const toggleMobileMenu = (event) => {
  if (event) {
    event.stopPropagation()
  }
  isMobileMenuOpen.value = !isMobileMenuOpen.value
  if (isMobileMenuOpen.value) {
    document.body.style.overflow = 'hidden'
  } else {
    document.body.style.overflow = ''
  }
}

// 关闭移动端菜单
const closeMobileMenu = () => {
  isMobileMenuOpen.value = false
  document.body.style.overflow = ''
  closeAllMenus()
}

// 检查当前路由
const isCurrentPage = (path) => {
  return router.currentRoute.value.path === path
}

// 移动端菜单项点击处理
const handleMobileMenuItemClick = (item, index, event) => {
  if (event) {
    event.stopPropagation()
  }
  
  if (item.isMenus) {
    // 阻止默认行为，防止页面跳转
    if (event) {
      event.preventDefault()
    }
    
    if (activeIndex.value === index) {
      navItems[index].ariaExpanded = !navItems[index].ariaExpanded
      if (!navItems[index].ariaExpanded) {
        activeIndex.value = -1
      }
    } else {
      if (activeIndex.value !== -1) {
        navItems[activeIndex.value].ariaExpanded = false
      }
      navItems[index].ariaExpanded = true
      activeIndex.value = index
    }
  } else {
    router.push(item.path)
    closeMobileMenu()
  }
}

// 修改子菜单项点击处理逻辑
const handleMobileSubItemClick = async (item, event) => {
  if (event) {
    event.stopPropagation()
    event.preventDefault()
  }
  
  // 先关闭移动端菜单
  closeMobileMenu()
  
  // 处理不同的跳转逻辑
  if (item.id === 'onlineConsultation') {
    // 在线咨询，延迟执行确保菜单已关闭
    setTimeout(() => {
      document.querySelector('.embed-icon-default')?.click()
    }, 300)
  } else if (item.id === 'accountManagement') {
    // 账户管理，新窗口打开
    window.open('https://saas.aidoully.com/user/profile', '_blank')
  } else if (item.id === 'requestTrial') {
    // 申请试用，跳转注册页面
    router.push('/register')
  } else {
    // 页面内锚点跳转
    try {
      // 延迟执行，确保DOM已更新
      await new Promise(resolve => setTimeout(resolve, 100))
      
      const element = document.getElementById(item.id)
      if (element) {
        scrollTo(element, {
          duration: 800,
          offset: -74,
          easing: 'easeInOut'
        })
      } else {
        console.warn(`元素 #${item.id} 未找到`)
        // 如果找不到元素，尝试跳转到对应页面后再查找
        const path = getPagePathByItemId(item.id)
        if (path) {
          router.push(path)
        }
      }
    } catch (error) {
      console.error('跳转失败:', error)
    }
  }
}

const getPagePathByItemId = (id) => {
  const idToPathMap = {
    'getOrder': '/products',
    'intelligentAccountingPprocessing': '/products',
    'automaticFulfillment': '/products',
    'dataStatisticalAnalysis': '/products',
    'productsFooter': '/products',
    'pricing': '/pricing',
    'frequentlyAskedQuestions': '/pricing',
    'requestTrial': '/solutions',
    'accountManagement': '/solutions',
    'onlineConsultation': '/solutions',
    'contactInformation': '/solutions',
    'on-demandCustomization': '/solutions',
    'expertKnowledge': '/about',
    'customerStories': '/about',
    'hotTopics': '/about'
  }
  
  return idToPathMap[id] || null
}

onMounted(() => {
  const header = document.querySelector('.friendation[is="basis-header"]')
  if (header) {
    headerHeight.value = header.offsetHeight
  }
  window.addEventListener('scroll', handleScroll)
  window.addEventListener('resize', handleResize) // 添加resize监听
  document.addEventListener('click', handleClickOutside)
  // 初始化检查一次
  // handleScroll()
})

onUnmounted(() => {
  window.removeEventListener('scroll', handleScroll)
  window.removeEventListener('resize', handleResize) // 移除resize监听
  document.removeEventListener('click', handleClickOutside)
})

const tryout = () => {
  router.push('/register')
  closeMobileMenu()
}

const login = () => {
  // const origin = window.location.origin
  const loginUrl = `https://saas.aidoully.com/app`
  window.open(loginUrl, '_blank')
  closeMobileMenu()
}

const toPage = (item, index) => {
  // 如果是当前页面，只切换菜单展开状态，不进行跳转
  if (isCurrentPage(item.path)) {
    if (activeIndex.value === index) {
      closeAllMenus()
    } else {
      // 关闭之前展开的菜单
      if (activeIndex.value !== -1) {
        navItems[activeIndex.value].ariaExpanded = false
      }
      // 展开当前菜单
      activeIndex.value = index
      item.ariaExpanded = true
    }
  } else {
    // 不同页面，进行跳转并收起菜单
    closeAllMenus()
    router.push(item.path)
  }
}

const goBack = () => {
  router.push('/')
  closeMobileMenu()
}

// 跳转对应模块
const scrollToElement = (id, event) => {
  if (id === "onlineConsultation") {
    document.querySelector('.embed-icon-default').click()
  } else if (id === "accountManagement") {
    window.open('https://saas.aidoully.com/user/profile', '_blank')
  } else if (event) {
    event.preventDefault()
    event.stopPropagation()
  }
  // 点击锚点链接时收起菜单
  closeAllMenus()

  if (id === 'requestTrial') {
    router.push('/register')
    return
  }
  const element = document.getElementById(id);
  scrollTo(element, {
    duration: 800,
    offset: -74,
    easing: 'easeInOut'
  })
}

// 点击其他地方关闭菜单
const handleClickOutside = (event) => {
  const header = document.querySelector('.friendation[is="basis-header"]')
  const mobileMenuDrawer = document.querySelector('.mobile-menu-drawer')
  const mobileMenuBtn = document.querySelector('.mobile-menu-btn')
  if (header && !header.contains(event.target) && mobileMenuDrawer && !mobileMenuDrawer.contains(event.target) &&
    mobileMenuBtn && !mobileMenuBtn.contains(event.target)) {
    closeAllMenus()
  }
}


</script>

<template>
  <!-- 顶部导航栏 -->
  <header class="mainHeader">
    <div class="friendation" is="basis-header"
      :class="{ 'slide-in': isTop, 'slide-out': !isTop, 'menu-expanded': activeIndex !== -1 }" data-scroll-top="true"
      :data-current-state="isTop ? 'visible' : 'hidden'">
      <div class="wrapper">
        <div class="container container-header" style="padding: 0 200px;">
          <div class="content-wrapper">
            <div class="logo">
              <div class="logo-text" @click="goBack"></div>
            </div>
            <div is="basis-mega-menue">
              <nav class="">
                <ul role="menubar">
                  <li role="menuitem" tabindex="0" data-level="0" :aria-expanded="item.ariaExpanded"
                    :data-focus="!item.ariaExpanded" v-for="(item, index) in navItems" :key="item.path"
                    :aria-current="activeIndex == index" @click="toPage(item, index)"
                    :class="{ 'current-page': isCurrentPage(item.path), 'has-dropdown': item.isMenus }">
                    <div class="paddingContainer">
                      <span>{{ item.text }}</span>
                    </div>
                    <div class="megaPanel" :class="{ 'slide-in': item.ariaExpanded, 'slide-out': !item.ariaExpanded }"
                      v-show="item.isMenus && item.ariaExpanded" role="menu" ref="menuRef">
                      <!-- 左：主入口，3 列卡片网格 -->
                      <div class="megaMain">
                        <div class="megaHead">
                          <span class="megaHead__title">{{ item.title }}</span>
                        </div>
                        <div class="megaGrid">
                          <a class="megaCard" role="menuitem" tabindex="-1" v-for="(entry, ei) in mainEntries(item)"
                            :key="ei" @click="scrollToElement(entry.id, $event)">
                            <span class="megaCard__title">{{ entry.text }}</span>
                            <span class="megaCard__desc" v-if="entry.remake">{{ entry.remake }}</span>
                          </a>
                        </div>
                      </div>
                      <!-- 右：扩展项侧栏 -->
                      <div class="megaAside" v-if="item.extensionsItems && item.extensionsItems.length">
                        <div class="megaHead">
                          <span class="megaHead__title">{{ item.extensions }}</span>
                        </div>
                        <div class="megaAsideList">
                          <a class="megaAsideList__link" :class="{ 'megaAsideList__link--more': ext.arrow }"
                            role="menuitem" tabindex="-1" v-for="(ext, xi) in item.extensionsItems" :key="xi"
                            @click="scrollToElement(ext.id, $event)">
                            <span>{{ ext.text }}</span>
                            <svg v-if="ext.arrow" class="megaAsideList__arrow" viewBox="0 0 16 16" aria-hidden="true">
                              <path d="M6.5 4 L10.5 8 L6.5 12" fill="none" stroke="currentColor" stroke-width="1.4"
                                stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                          </a>
                        </div>
                      </div>
                    </div>
                  </li>
                </ul>
              </nav>
            </div>
          </div>
          <div class="control-wrapper">
            <!-- 移动端菜单按钮 (只在小于1280px时显示) -->
            <div class="mobile-menu-btn" @click="toggleMobileMenu">
              <span></span>
              <span></span>
              <span></span>
            </div>
            <div class="buttons buttons--desktop">
              <button class="button button--cta button--secondary login-button-my"
                style="white-space: nowrap;border: none;" @click="login">
                登录
              </button>
              <button class="db-cta db-cta--solid db-cta--sm" @click="tryout">
                <span class="db-cta__label">免费注册</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <teleport to="body">
      <!-- 遮罩层 -->
      <div class="mobile-menu-overlay" :class="{ 'active': isMobileMenuOpen }" @click="closeMobileMenu"></div>

      <!-- 抽屉菜单 -->
      <div class="mobile-menu-drawer" :class="{ 'active': isMobileMenuOpen }">
        <div class="mobile-menu-header">
          <div class="logo-text" @click="goBack"></div>
          <button class="mobile-close-btn" @click="closeMobileMenu">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor"
              stroke-width="2">
              <line x1="18" y1="6" x2="6" y2="18"></line>
              <line x1="6" y1="6" x2="18" y2="18"></line>
            </svg>
          </button>
        </div>

        <div class="mobile-menu-content">
          <div v-for="(item, index) in navItems" :key="item.path" class="mobile-menu-item" :class="{
            'active': activeIndex === index,
            'current-page': isCurrentPage(item.path)
          }">
            <div class="mobile-menu-main" @click="handleMobileMenuItemClick(item, index, $event)">
              <span class="mobile-menu-text">{{ item.text }}</span>
              <span v-if="item.isMenus" class="mobile-menu-arrow">
                <svg :class="{ 'rotate': item.ariaExpanded }" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
                  <path fill="currentColor"
                    d="m8,9.86L3.35,5.22c-.2-.2-.51-.2-.71,0-.2.2-.2.51,0,.71l4.76,4.76c.33.33.85.33,1.18,0l4.76-4.76c.2-.2.2-.51,0-.71-.2-.2-.51-.2-.71,0l-4.65,4.65Z">
                  </path>
                </svg>
              </span>
            </div>

            <!-- 子菜单 -->
            <transition name="slide-down">
              <div v-if="item.isMenus && item.ariaExpanded" class="mobile-submenu">
                <div v-if="item.title" class="mobile-submenu-title">{{ item.title }}</div>

                <!-- 主菜单项（key 用下标：设计稿里同一个下拉存在同名条目） -->
                <div v-for="(menuItem, mi) in item.menuItems" :key="'a' + mi" class="mobile-submenu-item"
                  @click.stop="handleMobileSubItemClick(menuItem, $event)">
                  <div class="mobile-submenu-icon">
                    <img :src="menuItem.img" alt="" />
                  </div>
                  <div class="mobile-submenu-content">
                    <div class="mobile-submenu-text">{{ menuItem.text }}</div>
                    <div class="mobile-submenu-desc">{{ menuItem.remake }}</div>
                  </div>
                </div>

                <div v-for="(menuItem, mi) in item.menuItems1" :key="'b' + mi" class="mobile-submenu-item"
                  @click.stop="handleMobileSubItemClick(menuItem, $event)">
                  <div class="mobile-submenu-icon">
                    <img :src="menuItem.img" alt="" />
                  </div>
                  <div class="mobile-submenu-content">
                    <div class="mobile-submenu-text">{{ menuItem.text }}</div>
                    <div class="mobile-submenu-desc">{{ menuItem.remake }}</div>
                  </div>
                </div>

                <!-- 扩展项 -->
                <div v-if="item.extensions" class="mobile-submenu-title">{{ item.extensions }}</div>
                <div v-for="(extItem, xi) in item.extensionsItems" :key="'x' + xi" class="mobile-submenu-item"
                  @click.stop="handleMobileSubItemClick(extItem, $event)">
                  <div class="mobile-submenu-icon">
                    <img :src="extItem.img" alt="" />
                  </div>
                  <div class="mobile-submenu-content">
                    <div class="mobile-submenu-text">{{ extItem.text }}</div>
                  </div>
                </div>
              </div>
            </transition>
          </div>

          <!-- 移动端按钮 -->
          <div class="mobile-menu-actions">
            <button class="mobile-btn mobile-btn-login" @click="login">
              登录
            </button>
            <button class="mobile-btn mobile-btn-try" @click="tryout">
              免费注册
            </button>
          </div>
        </div>
      </div>
    </teleport>
  </header>
</template>
<style scoped>
.logo-text {
  width: 246px;
  height: 35px;
  background: url('/src/assets/images/logo-red.png');
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  cursor: pointer;
}

.slide-in {
  animation: slideIn 0.3s ease-out forwards;
}

.slide-out {
  animation: slideOut 0.3s ease-out forwards;
}

@keyframes slideIn {
  from {
    transform: translateY(0);
    opacity: 0;
  }

  to {
    transform: translateY(0);
    opacity: 1;
  }
}

@keyframes slideOut {
  from {
    transform: translateY(0);
    opacity: 1;
  }

  to {
    transform: translateY(0);
    opacity: 0;
  }
}

.friendation[is="basis-header"].menu-expanded {
  /* 当菜单展开时，可以添加一些特殊样式 */
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}

/* 当前页面菜单项的高亮样式
   设计稿里当前页不换色，只把字重从 400 提到 600（首页/价格/…都是 #1F2937） */
[role="menuitem"].current-page .paddingContainer {
  font-weight: 600;
  color: #1F2937;
}

/* 菜单展开时的平滑动画 */
[role="menu"] {
  transition: all 0.3s ease;
}

[role="menu"].slide-in {
  animation: slideDown 0.3s ease;
}

[role="menu"].slide-out {
  animation: slideUp 0.3s ease;
}

@keyframes slideDown {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes slideUp {
  from {
    opacity: 1;
    transform: translateY(0);
  }

  to {
    opacity: 0;
    transform: translateY(-10px);
  }
}

.login-button-my:hover {
  background: none !important;
}
.mobile-menu-btn {
  display: none;
  flex-direction: column;
  justify-content: space-between;
  width: 28px;
  height: 20px;
  padding: 0;
  background: transparent;
  border: none;
  cursor: pointer;
  z-index: 1002;
  margin-left: 20px;
}

.mobile-menu-btn span {
  display: block;
  height: 4px;
  width: 100%;
  background-color: #FE4554;
  border-radius: 4px;
  transition: all 0.3s ease;
}

/* 移动端菜单遮罩层 */
.mobile-menu-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 9998;
  opacity: 0;
  visibility: hidden;
  transition: opacity 0.3s ease, visibility 0.3s ease;
}

.mobile-menu-overlay.active {
  opacity: 1;
  visibility: visible;
}

/* 抽屉式菜单 */
.mobile-menu-drawer {
  position: fixed;
  top: 0;
  right: -100%;
  width: 85%;
  max-width: 400px;
  height: 100%;
  background-color: white;
  z-index: 9999;
  box-shadow: -2px 0 20px rgba(0, 0, 0, 0.15);
  transition: right 0.3s ease;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.mobile-menu-drawer.active {
  right: 0;
}

/* 抽屉头部 */
.mobile-menu-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px;
  border-bottom: 1px solid #eee;
  flex-shrink: 0;
}

.mobile-close-btn {
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: transparent;
  border: none;
  cursor: pointer;
  border-radius: 8px;
  transition: background-color 0.2s;
}

.mobile-close-btn:hover {
  background-color: #f5f5f5;
}

.mobile-close-btn svg {
  width: 24px;
  height: 24px;
  stroke: #333;
}

/* 菜单内容区域 */
.mobile-menu-content {
  flex: 1;
  overflow-y: auto;
  padding: 20px 0;
}

/* 菜单项 */
.mobile-menu-item {
  border-bottom: 1px solid #eee;
}

.mobile-menu-main {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 20px;
  cursor: pointer;
  font-size: 16px;
  font-weight: 500;
  transition: background-color 0.2s;
}

.mobile-menu-main:hover {
  background-color: #f9f9f9;
}

.mobile-menu-item.current-page .mobile-menu-main {
  color: #FE4554;
  font-weight: bold;
}

.mobile-menu-text {
  flex: 1;
}

.mobile-menu-arrow svg {
  width: 16px;
  height: 16px;
  transition: transform 0.3s ease;
  margin-left: 10px;
}

.mobile-menu-arrow svg.rotate {
  transform: rotate(180deg);
}

/* 子菜单动画 */
.slide-down-enter-active,
.slide-down-leave-active {
  transition: max-height 0.3s ease;
  overflow: hidden;
}

.slide-down-enter-from,
.slide-down-leave-to {
  max-height: 0;
}

.slide-down-enter-to,
.slide-down-leave-from {
  max-height: 1000px;
}

.mobile-submenu {
  background-color: #f9f9f9;
  padding: 10px 0;
}

.mobile-submenu-title {
  padding: 12px 20px 8px;
  font-size: 14px;
  color: #666;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.mobile-submenu-item {
  display: flex;
  align-items: flex-start;
  padding: 12px 20px;
  cursor: pointer;
  transition: background-color 0.2s;
}

.mobile-submenu-item:hover {
  background-color: #f0f0f0;
}

.mobile-submenu-icon {
  width: 32px;
  height: 32px;
  margin-right: 12px;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

.mobile-submenu-icon img {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
}

.mobile-submenu-content {
  flex: 1;
}

.mobile-submenu-text {
  font-size: 15px;
  font-weight: 500;
  margin-bottom: 4px;
  color: #333;
}

.mobile-submenu-desc {
  font-size: 13px;
  color: #666;
  line-height: 1.4;
}

/* 移动端按钮 */
.mobile-menu-actions {
  padding: 20px;
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-top: 20px;
}

.mobile-btn {
  width: 100%;
  padding: 14px 20px;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  text-align: center;
  border: none;
  transition: all 0.2s;
}

.mobile-btn-login {
  background-color: transparent;
  border: 1px solid #ddd;
  color: #333;
}

.mobile-btn-login:hover {
  background-color: #f5f5f5;
}

.mobile-btn-try {
  background-color: #FE4554;
  color: white;
}

.mobile-btn-try:hover {
  background-color: #e03e4d;
}

/* 响应式设计 */
@media (max-width: 1440px) {
  .container-header {
    padding: 0 !important;
  }
}

@media (max-width: 1280px) {
  .desktop-menu {
    display: none !important;
  }
  
  .mobile-menu-btn {
    display: flex;
  }
  
  .buttons--desktop {
    display: none !important;
  }
  
  .control-wrapper {
    display: flex;
    align-items: center;
  }
}

@media (min-width: 1281px) {
  .mobile-menu-btn {
    display: none !important;
  }
  
  .mobile-menu-overlay,
  .mobile-menu-drawer {
    display: none !important;
  }
}
@media (max-width: 800px) {
  .logo-text {
    width: 146px;
    height: 35px;
  }
}

/* =====================================================================
   顶栏改版：60px 高 / logo 153px、距左边框 30px、距右侧菜单 48px /
   右侧「登录」+「免费注册」（88×36、红橙渐变、距右边框 30px、间距 20px）
   ── main.css 里这些选择器权重普遍在 (0,4,0)，所以这里统一用
      .friendation[is="basis-header"] … 前缀，再叠上 scoped 的 [data-v]，
      抬到 (0,5,0)/(0,6,0)，不依赖样式注入顺序
   ===================================================================== */

/* ① 高度 59px + 1px 底边 = 60px（压掉 main.css 的 72 / 80(≥993) / 100(≥1536) 三档；
      设计稿导航是 0–58 白底 + 第 59 行 1px #E5E7EB，所以内容带只有 59 高） */
.friendation[is="basis-header"]>.wrapper {
  height: 59px;
}

/* ② 容器 inline 的 padding: 0 200px 只在 >1440px 时生效，这里全宽度清零，
      左右 30px 交给 .logo 和 .control-wrapper 自己管
      （作者样式表里的 !important 优先级高于普通 inline style，能压住它） */
.container-header {
  padding: 0 !important;
}

/* ③ logo：距左边框 30px、宽 153px、与右侧菜单间隔 48px */
.friendation[is="basis-header"] .logo {
  padding-left: 30px;
  padding-right: 0;
}

.friendation[is="basis-header"] .logo-text {
  width: 153px;
}

.friendation[is="basis-header"] .container>.content-wrapper {
  gap: 48px;
}

/* ④ 按钮组：距右边框 30px，「登录」与「免费注册」间隔 20px */
.friendation[is="basis-header"] .container>.control-wrapper {
  padding-right: 30px;
}

.friendation[is="basis-header"] .buttons--desktop {
  gap: 20px;
}

/* ⑤ 登录：纯文字按钮
      main.css 的 .button 带 min-width:44px + padding:12px 22px，
      会把「登录」两个字撑出一个 72px 宽的隐形盒子，导致它和「免费注册」的
      视觉间距变成 22+20=42px。这里把盒子收成和文字等宽（28px），
      20px 才是真正的视觉间距；纵向留 6px 让小按钮仍好点。 */
.friendation[is="basis-header"] .buttons--desktop .login-button-my {
  min-width: 0;
  min-height: 0;
  padding: 6px 0;
  border: 0;
  border-radius: 0;
  background-color: transparent;
  font-family: 'PingFang SC', 'Microsoft YaHei', sans-serif;
  font-weight: 500;
  font-size: 14px;
  line-height: 1.4;
  color: #4b5563;
}

/* main.css 的 .button--secondary:hover 会把前景刷成 #fff，
   而背景早被 .login-button-my:hover{background:none!important} 去掉 →
   白字白底，hover 时「登录」两个字直接看不见。这里把 hover 前景钉住。 */
.friendation[is="basis-header"] .buttons--desktop .login-button-my:hover,
.friendation[is="basis-header"] .buttons--desktop .login-button-my:focus-visible,
.friendation[is="basis-header"] .buttons--desktop .login-button-my:active {
  background-color: transparent;
  color: #f93131;
}

/* ⑥ 免费注册：88×36 胶囊 + 红橙渐变
      按钮本体（底色左右流动 + 外圈扩散光晕 + 扫光带，以及 hover 上浮 / active 归位 /
      focus-visible 描边 / prefers-reduced-motion 降噪）已收进全局
      src/assets/css/brandCta.css：.db-cta--solid + .db-cta--sm（88×36 / 14px / 圆角 100px）。
      原先为对抗 main.css 的 .button / .is-hoverable 而写的一整套覆盖
      （min-width / min-height / padding / ::before 光斑 / ::after 白箭头）随 class 一起删除 ——
      新按钮不再带 .button 类，main.css 那条链已经命中不到它，不会再被 reset 改形。
      容器 .buttons--desktop 的 gap:20px 负责「登录」与它之间的 20px。 */


/* ⑧ 一级菜单排版与间距 —— 按设计稿 14px / 400 / #1F2937
      设计稿文字位置（1920 视口）：首页 231、功能 283、价格 335、服务 387、知道 439；
      文字宽 28、文字间距 24 → 每项节拍 52。
      设计稿的 5 个文字之间没有任何箭头墨迹（310→335 那段是纯背景），
      所以展开箭头已按用户要求整块去掉，所有项一律 margin-right 24、
      节拍统一 52，5 个文字坐标与设计稿一个不差。 */
.friendation[is="basis-header"] ul[role="menubar"] {
  gap: 0;
}

.friendation[is="basis-header"] ul[role="menubar"]>[role="menuitem"] {
  margin: 0 24px 0 0;
  /* main.css 的 [data-level="0"]{font-weight:600} 是原型菜单的字重，设计稿是 400 */
  font-weight: 400;
  color: #1f2937;
}

.friendation[is="basis-header"] ul[role="menubar"]>[role="menuitem"]:last-child {
  margin-right: 0;
}

.friendation[is="basis-header"] ul[role="menubar"]>[role="menuitem"]>.paddingContainer {
  padding: 0;
  gap: 0;
  font-family: 'PingFang SC', -apple-system, BlinkMacSystemFont, 'Helvetica Neue', sans-serif;
  font-size: 14px;
  line-height: 20px;
}

/* main.css 里 hover 用的是老站红 #FE4554，统一成当前主题红 */
.friendation[is="basis-header"] ul[role="menubar"]>[role="menuitem"]:hover {
  color: #f93131;
}

/* ⑨ 底色与分隔线：设计稿是纯白 + 1px #E5E7EB 底边，没有投影
      （main.css 给 .container 挂了 background:#fff + 0 0 15px rgba(118,133,156,.25)） */
.friendation[is="basis-header"] {
  background-color: #ffffff;
  border-bottom: 1px solid #e5e7eb;
}

.friendation[is="basis-header"]>.wrapper>.container {
  box-shadow: none;
}

@media (max-width: 800px) {
  .friendation[is="basis-header"] .logo-text {
    width: 146px;
  }
}

/* ⑥ 的动效已收进全局 brandCta.css，统一由那里的 prefers-reduced-motion 处理 */


/* =====================================================================
   ⑩ 顶部下拉面板（蓝湖「官网-顶部下拉」设计稿）
   ── 1920 视口实测：面板自导航底边(y=60)起、全宽 1920、白底、
      底部 1px #E5E7EB、高 486；左栏 padding 0 48px 0 60px，
      主入口是 3 列卡片网格（卡 453×72 / gap 16 / 圆角 10 / hover #F3F4F6），
      标题带 40+26+12+1 = 79（分隔线落在 y=138）；
      右栏是 420px 的 #F8FAFC 侧栏 + 1px 左边框，内容宽 280、条目行距 54。
      main.css 同层级选择器权重 (0,4,1)，这里多挂一层 [is="basis-mega-menue"]
      抬到 (0,5,1)+，不依赖样式注入顺序。
   ===================================================================== */
.friendation[is="basis-header"] [is="basis-mega-menue"] nav [role="menubar"]>[role="menuitem"]>.megaPanel {
  position: absolute;
  left: 0;
  top: var(--header-height);
  width: 100% !important;
  max-width: none !important;
  margin: 0;
  padding: 0 !important;
  box-sizing: border-box;
  display: flex;
  align-items: stretch;
  min-height: 486px;
  overflow: visible;
  background-color: #ffffff;
  border-bottom: 1px solid #e5e7eb;
}

/* 标题带（左右栏共用）：18px/26 红字，下压 12 + 1px 分隔线 */
.friendation[is="basis-header"] [is="basis-mega-menue"] nav [role="menubar"]>[role="menuitem"]>.megaPanel .megaHead {
  padding: 40px 0 12px;
  box-sizing: border-box;
  border-bottom: 1px solid #e5e7eb;
}

.friendation[is="basis-header"] [is="basis-mega-menue"] nav [role="menubar"]>[role="menuitem"]>.megaPanel .megaHead__title {
  display: block;
  font-family: 'PingFang SC', -apple-system, BlinkMacSystemFont, 'Helvetica Neue', sans-serif;
  font-size: 18px;
  line-height: 26px;
  font-weight: 600;
  color: #f93131;
  white-space: nowrap;
}

/* 左栏：1920 下 = 1920 - 420(侧栏) - 60 - 48 = 1392，3 列 (1392-32)/3 ≈ 453 */
.friendation[is="basis-header"] [is="basis-mega-menue"] nav [role="menubar"]>[role="menuitem"]>.megaPanel>.megaMain {
  flex: 1 1 auto;
  min-width: 0;
  padding: 0 48px 0 60px;
  box-sizing: border-box;
}

/* 标题带左右各缩 16，让分隔线与卡片文字左缘(76)对齐 */
.friendation[is="basis-header"] [is="basis-mega-menue"] nav [role="menubar"]>[role="menuitem"]>.megaPanel>.megaMain>.megaHead {
  margin: 0 16px;
}

.friendation[is="basis-header"] [is="basis-mega-menue"] nav [role="menubar"]>[role="menuitem"]>.megaPanel .megaGrid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 16px;
  align-content: start;
  margin: 24px 0 0;
  padding: 0;
}

.friendation[is="basis-header"] [is="basis-mega-menue"] nav [role="menubar"]>[role="menuitem"]>.megaPanel .megaCard {
  display: block;
  width: 100%;
  min-height: 72px;
  padding: 14px 16px;
  box-sizing: border-box;
  border-radius: 10px;
  text-decoration: none;
  cursor: pointer;
  transition: background-color 0.25s ease;
}

.friendation[is="basis-header"] [is="basis-mega-menue"] nav [role="menubar"]>[role="menuitem"]>.megaPanel .megaCard:hover,
.friendation[is="basis-header"] [is="basis-mega-menue"] nav [role="menubar"]>[role="menuitem"]>.megaPanel .megaCard:focus-visible {
  background-color: #f3f4f6;
}

.friendation[is="basis-header"] [is="basis-mega-menue"] nav [role="menubar"]>[role="menuitem"]>.megaPanel .megaCard__title {
  display: block;
  font-family: 'PingFang SC', -apple-system, BlinkMacSystemFont, 'Helvetica Neue', sans-serif;
  font-size: 16px;
  line-height: 22px;
  font-weight: 600;
  color: #0b121f;
}

.friendation[is="basis-header"] [is="basis-mega-menue"] nav [role="menubar"]>[role="menuitem"]>.megaPanel .megaCard__desc {
  display: block;
  margin: 2px 0 0;
  font-family: 'PingFang SC', -apple-system, BlinkMacSystemFont, 'Helvetica Neue', sans-serif;
  font-size: 14px;
  line-height: 20px;
  font-weight: 400;
  color: #374151;
}

/* 右栏侧栏：420 含 1px 左边框，内容 280 */
.friendation[is="basis-header"] [is="basis-mega-menue"] nav [role="menubar"]>[role="menuitem"]>.megaPanel>.megaAside {
  flex: 0 0 420px;
  width: 420px;
  padding: 0 64px;
  box-sizing: border-box;
  background-color: #f8fafc;
  border-left: 1px solid #e5e7eb;
}

.friendation[is="basis-header"] [is="basis-mega-menue"] nav [role="menubar"]>[role="menuitem"]>.megaPanel>.megaAside>* {
  max-width: 280px;
}

/* 侧栏条目：16px/22 + 上下 16 内距 = 每条 54，与设计稿行距一致 */
.friendation[is="basis-header"] [is="basis-mega-menue"] nav [role="menubar"]>[role="menuitem"]>.megaPanel .megaAsideList {
  margin: 28px 0 0;
  padding: 0;
}

.friendation[is="basis-header"] [is="basis-mega-menue"] nav [role="menubar"]>[role="menuitem"]>.megaPanel .megaAsideList__link {
  display: block;
  width: 100%;
  padding: 16px 0;
  box-sizing: border-box;
  font-family: 'PingFang SC', -apple-system, BlinkMacSystemFont, 'Helvetica Neue', sans-serif;
  font-size: 16px;
  line-height: 22px;
  font-weight: 500;
  color: #0b121f;
  text-decoration: none;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  cursor: pointer;
  transition: color 0.25s ease;
}

.friendation[is="basis-header"] [is="basis-mega-menue"] nav [role="menubar"]>[role="menuitem"]>.megaPanel .megaAsideList__link:hover,
.friendation[is="basis-header"] [is="basis-mega-menue"] nav [role="menubar"]>[role="menuitem"]>.megaPanel .megaAsideList__link:focus-visible {
  color: #f93131;
}

/* 末档「更多内容 ›」：红字 + 右向箭头（设计稿箭头 16×16，紧跟文字后约 8） */
.friendation[is="basis-header"] [is="basis-mega-menue"] nav [role="menubar"]>[role="menuitem"]>.megaPanel .megaAsideList__link--more {
  display: flex;
  align-items: center;
  gap: 8px;
  color: #f93131;
}

.friendation[is="basis-header"] [is="basis-mega-menue"] nav [role="menubar"]>[role="menuitem"]>.megaPanel .megaAsideList__link--more>span {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
}

.friendation[is="basis-header"] [is="basis-mega-menue"] nav [role="menubar"]>[role="menuitem"]>.megaPanel .megaAsideList__arrow {
  flex: none;
  width: 16px;
  height: 16px;
}

/* 1280–1600：侧栏收窄，左栏留白同步收，免得卡片里的说明被挤成两行 */
@media (max-width: 1600px) {
  .friendation[is="basis-header"] [is="basis-mega-menue"] nav [role="menubar"]>[role="menuitem"]>.megaPanel>.megaMain {
    padding: 0 40px 0 48px;
  }

  .friendation[is="basis-header"] [is="basis-mega-menue"] nav [role="menubar"]>[role="menuitem"]>.megaPanel>.megaAside {
    flex: 0 0 360px;
    width: 360px;
    padding: 0 48px;
  }

  .friendation[is="basis-header"] [is="basis-mega-menue"] nav [role="menubar"]>[role="menuitem"]>.megaPanel>.megaAside>* {
    max-width: none;
  }
}

@media (max-width: 1366px) {
  .friendation[is="basis-header"] [is="basis-mega-menue"] nav [role="menubar"]>[role="menuitem"]>.megaPanel .megaGrid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

</style>

<!--
  非 scoped：顶栏改成固定 60px 后，--header-height 必须同步，
  否则用 calc(var(--header-height) + 83px) 的地方（价格页 hero 距导航 83px）会多出 20px。
  main.css 里 :root 有 72 / 80(≥993) / 100(≥1536) 三档，用 html:root 抬一级特异性，
  比 :root 高一层，且不受样式注入顺序影响。
-->
<style>
html:root {
  --header-height: 60px;
}
</style>
